/**
 * Приводит кану к единому виду для поиска: хирагана → катакана.
 * Знак долготы ー (U+30FC) общий для обеих азбук и не трогается.
 * Half-width катакану приводит к full-width вызывающий код
 * через String.prototype.normalize('NFKC') ДО вызова этой функции.
 */
export function toKatakana(str) {
  return str.replace(/[ぁ-ゖ]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) + 0x60));
}
